import {PlayGameDeepLinkActionBase} from '../play-game-deep-link-action-base';

export class PlayGameRealDeepLinkAction extends PlayGameDeepLinkActionBase {
  protected getIsRealMode(): boolean {
    return true;
  }
}
